  <template>
  <div class="flex flex-row justify-center">
    <MenuDropDown
      v-for="(links, idx) in routerLinks"
      :key="idx"
      ref="solutionsDropdown"
      :data-test="idx"
      :name="idx.toString().replace('_', ' ')"
      class="relative cursor-pointer w-full">
      <template #dropdown-items>
        <div class="dropdown top-[30px]">
          <ul class="flex flex-col gap-y-[20px]">
            <li v-for="(link, index) in links" :key="index" class="flex">
              <RouterLink
                :data-test="link.id"
                :to="link.link"
                class="text-grey-1 font-bold hover:text-primary">
                {{ link.name }}
              </RouterLink>
            </li>
          </ul>
        </div>
      </template>
    </MenuDropDown>
  </div>
</template>

<script lang="ts" setup>
import MenuDropDown from '@/components/BasicInputs/DropDown/MenuDropDown.vue'
import { getLinksForWhitelabel } from '@/composables/getLinksForWhitelabel.ts'

type RouterLink = {
  name: string
  link: string
  id: string
}

interface RouterLinks {
  [key: string]: Array<RouterLink>
}

const routerLinks: RouterLinks = getLinksForWhitelabel(false)
</script>

<style lang="scss" scoped>
.router-link.router-link-active {
  fill: #0064ff;
  color: #ffffff;
}

::deep(.plan-icon) {
  height: 2.5rem;
  width: 2.5rem;
}

.dropdown {
  display: flex;
  position: absolute;
  border-radius: 0.25rem;
  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  width: 205px;
  padding: 20px;
  background-color: #ffffff;
  color: #000000;
}
</style>
